import React from 'react';
import { Badge, Tooltip, Spinner } from '@chakra-ui/react';
import { FaCheckCircle, FaExclamationCircle, FaExclamationTriangle } from 'react-icons/fa';

const MediaStatusBadge = ({ mediaGenerationStatus, mediaGenerationEnabled }) => {
  // Don't show badge if media generation was never enabled
  if (!mediaGenerationEnabled) {
    return null;
  }

  // Don't show badge if status is not_requested
  if (mediaGenerationStatus === 'not_requested') {
    return null;
  }

  // Define status configurations
  const statusConfig = {
    queued: {
      colorScheme: 'blue',
      icon: <Spinner size="xs" />,
      text: 'Generating Media',
      tooltip: 'Media generation is queued and will begin shortly'
    },
    pending: {
      colorScheme: 'blue',
      icon: <Spinner size="xs" />,
      text: 'Generating Media',
      tooltip: 'Media generation is queued and will begin shortly'
    },
    processing: {
      colorScheme: 'blue',
      icon: <Spinner size="xs" />,
      text: 'Generating Media',
      tooltip: 'Media is currently being generated'
    },
    completed: {
      colorScheme: 'green',
      icon: <FaCheckCircle />,
      text: 'Media Ready',
      tooltip: 'All media has been successfully generated'
    },
    failed: {
      colorScheme: 'red',
      icon: <FaExclamationCircle />,
      text: 'Media Failed',
      tooltip: 'Media generation failed. Please try regenerating.'
    },
    partial_success: {
      colorScheme: 'yellow',
      icon: <FaExclamationTriangle />,
      text: 'Partial Media',
      tooltip: 'Some media generated successfully, but some failed'
    }
  };

  const config = statusConfig[mediaGenerationStatus];

  // If status is unknown or not configured, don't show badge
  if (!config) {
    return null;
  }

  return (
    <Tooltip label={config.tooltip} placement="top" hasArrow>
      <Badge
        colorScheme={config.colorScheme}
        display="inline-flex"
        alignItems="center"
        gap={1}
        px={2}
        py={1}
        borderRadius="md"
        fontSize="xs"
        fontWeight="medium"
      >
        {config.icon}
        <span>{config.text}</span>
      </Badge>
    </Tooltip>
  );
};

export default MediaStatusBadge;